<div class="row" *ngIf="commonService.appointmentDetails">
    <div class="col-12 col-md-12">
        <div class="row">
            <div class="col-6 col-lg-6 col-xl-2">
                <div class="af-form-group">
                    <label class="" translate>lblAppointmentType</label>

                    <div class="flexbox align-items-center">

                        <div class="flexbox form-check pl-0">
                            <input type="radio" class="radio-custom m-0" id="quote" name="offertype" value="Quote"
                                disabled="true"
                                [(ngModel)]="commonService.editAppointmentService.appointmentDetails.appointmentType" />
                            <label translate class="text-dark ml-2" for="quote">
                                lblQuote
                            </label>
                        </div>
                        <div class="flexbox form-check ml-5">
                            <input type="radio" class="radio-custom m-0" id="order" name="offertype" disabled="true"
                                [(ngModel)]="commonService.editAppointmentService.appointmentDetails.appointmentType"
                                value="Order" />
                            <label translate class="text-dark ml-2" for="order">
                                lblOrder
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2">
                <div class="af-form-group">
                    <label>
                        <span translate>lblCustomer</span> / <span translate>lblOwner</span>
                    </label>
                    <div class="lbl-info">
                        {{commonService.appointmentDetails.customerName}}
                        <span
                            *ngIf="commonService.contactDetails && commonService.contactDetails.ownerName ;else load_OwnerNotFound">
                            <span
                                *ngIf="commonService.appointmentDetails.customerName.toLowerCase() !== commonService.contactDetails.ownerName.toLowerCase()">
                                / {{commonService.contactDetails.ownerName}}
                            </span>
                        </span>
                        <ng-template #load_OwnerNotFound>
                            <span translate>/ -</span>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2">
                <div class="af-form-group">
                    <label translate>lblDealersName</label>
                    <div class="lbl-info">
                        {{commonService.appointmentDetails.dealerName}}
                        <button class="btn btn-link ml-2" (click)="commonService.copyTextDealer()" placement="top"
                            ngbTooltip="Copy Dealer" aria-label="Center Align">
                            <em class="fas fa-copy fa-lg"></em>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2">
                <div class="af-form-group">
                    <label translate>lblAppointmentStatus</label>
                    <div class="lbl-info">
                        <div class="color-box"
                            [style.background-color]="commonService.appointmentDetails.appointmentStatusColor">
                        </div>
                        {{commonService.appointmentStatusName}}
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2"
                *ngIf="commonService.editAppointmentService.isEdit && !commonService.editAppointmentService.appointmentDetails.isFromArchive">
                <div class="af-form-group">
                    <label translate>lblChangeStatus</label>
                    <div class="lbl-info">
                        <ng-select [(ngModel)]="SelectedStatus" [ngModelOptions]="{standalone: true}"
                            [disabled]="StatusDisabled" placeholder="{{ 'lblSelectStatus' | translate }}"
                            (change)="onStatusChange()" (clear)="resetCalculations()">
                            <ng-option *ngFor="let status of commonService.statusList" [value]="status.id">
                                {{status.name}}
                            </ng-option>
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2"
                *ngIf="commonService.editAppointmentService.isEdit && !commonService.editAppointmentService.appointmentDetails.isFromArchive && isDocumentPartStatusActive">
                <div class="af-form-group">
                    <label translate>lblDocumentPartStatus</label>
                    <div class="lbl-info">
                        <ng-select [(ngModel)]="commonService.SelectedDocumentPartStatus"
                            [ngModelOptions]="{standalone: true}" [disabled]="StatusDisabled"
                            placeholder="{{ 'lblSelectStatus' | translate }}"
                            (change)="commonService.onDocumentPartStatusChange()" (clear)="resetDocumetStatus()">
                            <ng-option *ngFor="let status of commonService.documentPartStatus" [value]="status.code">
                                {{status.code}}
                            </ng-option>
                        </ng-select>
                    </div>
                </div>
            </div>

            <div class="col-6 col-lg-6 col-xl-2">
                <div class="af-form-group">
                    <label>
                        <span translate>lblWoNo</span>
                    </label>
                    <div class="lbl-info">
                        <span class="lbl-info" *ngIf="commonService.appointmentDetails.workOrderNo;else load_WoNoelse">#
                            {{commonService.appointmentDetails.workOrderNo}}</span>
                        <button class="btn btn-link ml-2" (click)="commonService.copyWorkOrderNumber()" placement="top"
                            ngbTooltip="Copy WO No." aria-label="Center Align">
                            <em class="fas fa-copy fa-lg"></em>
                        </button>
                        <ng-template #load_WoNoelse>
                            <span class="lbl-info" translate>-</span>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6 col-xl-2">
                <div class="af-form-group">
                    <label translate>lblSourceCreation</label>
                    <div class="lbl-info">
                        <div class=" flex-wrap sourceBox">
                            {{commonService.appointmentDetails.sourceCreation}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-6 col-xl-2">
                <div class="af-form-group">
                    <label>
                        <span translate>lblRegNumber</span>
                    </label>
                    <div class="lbl-info">
                        <div class="flmid flex-wrap">
                            <div class="licplate LPNo d-flex">
                                <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                {{commonService.appointmentDetails.licensePlate}}
                            </div>
                            <div class="imgWid">
                                <ng-container>
                                    <img af-brand-logo [data-code]="commonService.appointmentDetails.brandCode" data-type="BRAND"
                                        class="{{commonService.appointmentDetails.brandCode}}-icon common"
                                        [title]="commonService.appointmentDetails.brandCode" class="brandicon"
                                        alt="img" />
                                </ng-container>
                                <button class="btn btn-link ml-2" (click)="commonService.copyTextRegistrationNumber()"
                                    placement="top" ngbTooltip="Copy Reg No." aria-label="Center Align">
                                    <em class="fas fa-copy fa-lg"></em>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2">
                <div class="af-form-group">
                    <label translate>lblVinNumber</label>
                    <div class="lbl-info">
                        {{commonService.appointmentDetails.chassisNo}}
                        <button class="btn btn-link ml-2" (click)="commonService.copyTextVINNumber()" placement="top"
                            ngbTooltip="Copy VIN No." aria-label="Center Align">
                            <em class="fas fa-copy fa-lg"></em>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2" *ngIf="commonService.contactDetails">
                <div class="af-form-group">
                    <label translate>lblWoStatus</label>
                    <div class="lbl-info">
                        <div class="color-box"
                            [style.background-color]="commonService.appointmentDetails.workOrderStatusColor"></div>
                        {{commonService.appointmentDetails.workOrderStatus}}
                        <span *ngIf="commonService.IsonHoldStatus">
                            ({{commonService.contactDetails.onHoldReason}})
                            <span *ngIf="commonService.contactDetails.onHoldReasonDescription">

                                <em class="fas fa-info-circle fa-lg" placement="top"
                                    [ngbTooltip]="commonService.contactDetails.onHoldReasonDescription"></em>

                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2" *ngIf="commonService.contactDetails">
                <div class="af-form-group">
                    <label>
                        <span translate>lblAssignedMechanic</span>
                    </label>
                    <div class="lbl-info">
                        <span class="lbl-info"
                            *ngIf="(commonService.contactDetails.plannedMechanics || commonService.contactDetails.pastPlannedMechanics) else elsePlannedMechanics">
                            <span class="text-muted">{{commonService.contactDetails.pastPlannedMechanics}}</span>
                            <span class="text-muted"
                                *ngIf="commonService.contactDetails.pastPlannedMechanics && commonService.contactDetails.plannedMechanics">,
                            </span>
                            <span class="font-weight-bold">{{commonService.contactDetails.plannedMechanics}}</span>
                        </span>
                        <ng-template #elsePlannedMechanics>
                            <span class="lbl-info" translate>lblNotYetAssigned</span>
                        </ng-template>
                    </div>
                </div>
            </div>

            <div class="col-6 col-lg-6 col-xl-2" [hidden]="true">
                <div class="af-form-group">
                    <label>
                        <span translate>lblSalesPerson</span>
                    </label>
                    <div class="lbl-info">
                        <ng-select [(ngModel)]="commonService.SelectedSalesPerson" [ngModelOptions]="{standalone: true}"
                            [disabled]="StatusDisabled" placeholder="{{ 'lblSelectSalesPerson' | translate }}"
                            (change)="commonService.onSalesPersonChange()"
                            (clear)="commonService.resetSalesPersonList()">
                            <ng-option *ngFor="let item of salesPersonList" [value]="item.id">
                                [{{item.code}}] {{item.name}}
                            </ng-option>
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2">
                <div class="af-form-group">
                    <label translate>lblModel</label>
                    <div class="lbl-info">
                        {{commonService.appointmentDetails.modelName}}
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2" *ngIf="commonService.contactDetails">
                <div class="af-form-group">
                    <label translate>lbl1stRegistrationDate</label>
                    <div class="lbl-info">
                        {{commonService.contactDetails.registrationDate}}
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2" *ngIf="commonService.contactDetails">
                <div class="af-form-group">
                    <label translate>lblMileage</label>
                    <div class="lbl-info">
                        <div class="d-flex align-items-center">
                            <div class="lbl-info relative km-block">
                                <input type="text" class="form-control kminput text-right"
                                    [value]="commonService.contactDetails.kilometer"
                                    [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                                    [(ngModel)]="commonService.contactDetails.kilometer" min="0" required maxlength="9"
                                    [ngClass]="(+commonService.contactDetails.kilometer) === (+commonService.contactDetails.previousKilometer) ? 'bg-danger' : '' " />
                                <span class="mil-km">KM</span>
                            </div>
                            <div *ngIf ="commonService.contactDetails?.mileageUpdateBy || commonService.contactDetails?.mileageUpdateDate" class="af-form-group mileage pl-2">
                                {{commonService.contactDetails.mileageUpdateBy}} <br/>
                                {{commonService.contactDetails.mileageUpdateDate}}
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2">
                <div class="af-form-group">
                    <label>
                        <span translate>lblEUControl</span>
                    </label>
                    <div class="lbl-info" *ngIf="commonService.appointmentPKKDate else elseEUDate">
                        {{ commonService.appointmentPKKDate}}
                    </div>
                    <ng-template class="lbl-info" #elseEUDate>
                        -
                    </ng-template>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2" *ngIf="commonService.contactDetails">
                <div class="af-form-group">
                    <label translate>lblBookedDate</label>
                    <div class="lbl-info" *ngIf="commonService.appointmentBookedDate">
                        {{commonService.appointmentBookedDate | date:'short'}}
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2">
                <div class="af-form-group">
                    <label translate>lblCreatedDate</label>
                    <div class="lbl-info" *ngIf="commonService.appointmentCreatedDate">
                        {{commonService.appointmentCreatedDate | date:'short'}}
                    </div>
                </div>
            </div>




            <div class="col-6 col-lg-6 col-xl-2" *ngIf="commonService.contactDetails">
                <div class="af-form-group">
                    <label translate>lblContactName</label>
                    <div class="lbl-nfo">
                        <input type="text" class="form-control"
                            [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                            [(ngModel)]="commonService.contactDetails.contactInfo" />
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2" *ngIf="commonService.contactDetails">
                <div class="af-form-group">
                    <label translate>lblContactMobile</label>
                    <div class="lbl-nfo">
                        <ngx-intl-tel-input [selectFirstCountry]= "false" [cssClass]="{'form-control': true}" [selectedCountryISO]="selectedCountryISO" [maxLength]="15" [phoneValidation]="false"
                        [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false" 
                        [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                        [(ngModel)]="commonService.singlePhoneNo" (countryChange)="onNomineeCountryChange($event)"
                        (ngModelChange)="onChangePhoneNo()"
                        ></ngx-intl-tel-input>
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2" *ngIf="commonService.contactDetails && isOfferFeatureActive">
                <ng-container>
                    <em class="fas fa-check fa-lg" *ngIf="commonService.contactDetails.contactUser === true"></em>
                    <em class="fas fa-times text-danger fa-lg"
                        *ngIf="commonService.contactDetails.contactUser === false"></em>
                </ng-container>
                <ng-container>
                    <label class="form-check-label" translate>lblCurrentOffer</label>
                </ng-container>
            </div>
            <div class="col-6 col-lg-6 col-xl-2">
                <div class="af-form-group">
                    <label translate>lblLastUpdatedDate</label>
                    <div class="lbl-info" *ngIf="commonService.appointmentUpdatedDate else elseUpdatedDate">
                        {{ commonService.appointmentUpdatedDate | date:'short'}}
                    </div>
                    <ng-template class="lbl-info" #elseUpdatedDate>
                        NA
                    </ng-template>

                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2" *ngIf="commonService.contactDetails">
                <ng-container>
                    <div>
                        <em class="fa fa-exclamation-triangle text-warning fa-lg"
                            *ngIf="commonService.contactDetails.needAttention === 1"></em>
                        <em class="fas fa-times text-danger fa-lg cursordisable"
                            *ngIf="commonService.contactDetails.needAttention === 0"></em>
                        <label class="form-check-label"
                            *ngIf="commonService.contactDetails.needAttention === 0 || commonService.contactDetails.needAttention === 1"
                            translate>lblNeedAttention</label>
                        <em class="fas fa-check fa-lg" *ngIf="commonService.contactDetails.needAttention === 2">
                            <label class="form-check-label" translate>lblResolved</label>
                        </em>
                        <button class="btn btn-primary mr-sm-2 ml-3 btn-sm"
                            *ngIf="commonService.contactDetails.needAttention === 1" (click)="UpdateNeedAttention()"
                            [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                            translate aria-label="Center Align">
                            lblResolve 
                        </button>
                    </div>
                </ng-container>
                <ng-container>
                    <div
                        *ngIf="commonService.contactDetails.isCheckInDoneByCustomer === true  && commonService.contactDetails.workorderStatusId !=12">
                        <em class="fas fa-check fa-lg"></em>
                        <label class="form-check-label" style="margin-top:5px" translate>lblCheckInCompleted</label>
                    </div>
                    <div *ngIf="commonService.contactDetails.isCheckInDoneByCustomer === false">
                        <em class="fas fa-times text-danger fa-lg cursordisable"></em>
                        <label class="form-check-label" style="margin-top:5px" translate>lblCheckInCompleted</label>
                    </div>
                    <div class="d-flex">
                        <div *ngIf="commonService.isShowGenerateAndSendCheckInButton">
                            <button class="btn btn-link  btn-lg" (click)="generateAndSendCheckinLink()" placement="top"
                                ngbTooltip="{{ 'lblGenerateAndSMSCheckInLink' | translate }}" aria-label="Center Align">
                                <em class="icon-tracker-mail font26"></em>
                            </button>
                        </div>
                        <span class="ico-div"></span>
                        <div *ngIf="commonService.isShowGenerateTrackerButton" class="ml-2">
                            <button class="btn btn-link  btn-lg" (click)="generateTrackerLink()" placement="top"
                                ngbTooltip="{{ 'lblGenerateTrackerLink' | translate }}" aria-label="Center Align">
                                <em class="icon-tracker font26"></em>
                            </button>
                            <button class="btn btn-link ml-2 btn-lg" (click)="generateAndSendTrackerLink()" placement="top"
                                ngbTooltip="{{ 'lblGenerateAndSMSTrackerLink' | translate }}" aria-label="Center Align">
                                <em class="icon-tracker-mail font26"></em>
                            </button>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="IsonHoldStatus">
                    <div>
                        <em class="fas fa-check fa-lg" *ngIf="commonService.contactDetails.isCarRemainInWorkshop"></em>
                        <em class="fas fa-times text-danger fa-lg"
                            *ngIf="commonService.contactDetails.isCarRemainInWorkshop === false"></em>
                        <label class="form-check-label" style="margin-top:5px"
                            translate>lblCarWillRemainInWorkshop</label>
                    </div>
                </ng-container>
            </div>
            <div class="col-6 col-lg-6 col-xl-2" *ngIf="commonService.contactDetails && isShiftAppointment">
                <div class="af-form-group">
                    <button class="btn btn-primary mr-sm-2 btn-sm" (click)="ShiftAppointment(shiftAppointment)"
                        *ngIf="commonService.editAppointmentService.isEdit && !commonService.editAppointmentService.appointmentDetails.isFromArchive"
                        [disabled]="commonService.appointmentDetails.workOrderStatusId === 0 
        || commonService.appointmentDetails.workOrderStatusId === 3 
        || commonService.appointmentDetails.workOrderStatusId === 4
        || commonService.appointmentDetails.workOrderStatusId === 5 
        || commonService.appointmentDetails.workOrderStatusId === 6
              || commonService.appointmentDetails.workOrderStatusId === 7
              || commonService.appointmentDetails.workOrderStatusId === 11 
              || commonService.appointmentDetails.workOrderStatusId === 9 
              || commonService.appointmentDetails.workOrderStatusId === 10" translate aria-label="Center Align">
                        <em class="far fa-save font16 align-top mr-2"></em>
                        lblShiftAppointment</button>
                    <span *ngIf="commonService.contactDetails.remark?.length > 0">
                        <a class="btn btn-ico" (click)="commonService.ViewRemark(viewContent)">
                            <em class="fas fa-eye fa-lg"></em>
                            <span class="position-absolute translate-middle badge rounded-pill count" *ngIf="commonService.internalComments?.length > 0"
                                style="margin-top: 2px !important; background-color: #ED5153; color: #ffff;">
                                {{commonService.internalComments?.length}} </span>
                        </a>
                    </span>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2" *ngIf="commonService.contactDetails?.isCreatedByCall">
                <div class="af-form-group">
                    <label translate>lblCreatedBy</label>
                    <div class="lbl-info">
                        {{ commonService.contactDetails.createdBy }}
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-2" *ngIf="commonService.contactDetails">
                <div class="af-form-group">
                    <label translate>lblParkingNote</label>
                    <div class="lbl-nfo">
                        <input type="text" class="form-control"
                            [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                            [(ngModel)]="commonService.contactDetails.parkingNote" maxlength="50" />
                    </div>
                </div>
            </div>
            <div style="margin-top: 10px; margin-bottom: 10px;" *ngIf="isShareBoxEnabled && (editAppointmentService.appointmentDetails.isKeyDrop || editAppointmentService.appointmentDetails.isAutoKey)">
                <label translate>lblShareboxStatus</label> <span *ngIf="editAppointmentService.appointmentDetails.sentShareboxInfo"><img src="../../../../../../assets/images/sharebox0.png" width="25" style="margin-left: 1rem; margin-bottom: 2px;"/></span>
                <ng-container>
                    <div *ngIf="editAppointmentService.appointmentDetails.sentShareboxInfo && (editAppointmentService.appointmentDetails.isKeyDrop || editAppointmentService.appointmentDetails.isAutoKey)">
                        <em class="fas fa-check fa-lg"></em>
                        <label class="form-check-label" style="margin-top:5px" translate>lblShareboxInfoSent</label>
                    </div>
                    <div
                        *ngIf="!editAppointmentService.appointmentDetails.sentShareboxInfo && (editAppointmentService.appointmentDetails.isKeyDrop || editAppointmentService.appointmentDetails.isAutoKey)">
                        <em class="fas fa-times text-danger fa-lg cursordisable"></em>
                        <label class="form-check-label" style="margin-top:5px" translate>lblShareboxInfoNotSent</label>
                    </div>
                </ng-container>
            </div>    
        </div>
    </div>

</div>

<ng-template #shiftAppointment let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblShiftAppointment</h4>
        <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
            (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">

        <div class="card pad15">
            <div class="col-12">
                <label translate>lblDealersName</label><span class="text-danger"> *</span>
                <div class="lbl-info">
                    <ng-select [ngModelOptions]="{standalone: true}" placeholder="{{ 'lblSelectDealer' | translate }}"
                        (change)="onDealerChange($event)" appendTo="body">
                        <ng-option *ngFor="let dealer of commonService.dealers" [value]="dealer.dealerId">
                            {{dealer.name}}
                        </ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="col-12 mt-3">
                <div class="af-form-group">
                    <label translate>lblRemark</label>
                    <textarea class="form-control" name="textDescription" [(ngModel)]="remark" maxlength="1000">

          </textarea>
                </div>
            </div>
        </div>

    </div>

    <div class="modal-footer">
        <div class="d-flex flex-sm-row flex-column justify-content-end">
            <button type="submit" class="btn btn-primary mr-sm-2" translate (click)="ChangeDealerOfAppoitment()"
                aria-label="Center Align">lblOk</button>
            <button (click)="modal.dismiss('Cross click')" class="btn btn-secondary" aria-label="Center Align"
                translate>lblCancel</button>
        </div>
    </div>
</ng-template>

<ng-template #viewContent let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblRemark
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"><span
                aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive remark">
        <div style="margin: 15px;">{{commonService.contactDetails?.remark}}</div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md" (click)="modal.close('Cancel click')"
            translate>lblCancel</button>
    </div>
</ng-template>